import {MediaConfig} from '../../dataTypes'
import {isImageFile, isVideoFile} from '../../lib'

type Props = {
  media: MediaConfig
}

export const PortraitTouchRvmPreview = ({media}: Props) => {
  const mediaUrl = media.customMedia?.filenamePath || media.defaultFilenamePath
  const contentType = media.customMedia?.contentType || media.defaultMediaContentType
  return (
    <div
      style={{
        backgroundImage: 'url(' + process.env.PUBLIC_URL + '/images/touchportrait_bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: '545px',
        height: '402px',
        position: 'relative',
        marginBottom: '20px',
      }}
    >
      <div
        style={{
          width: '120px',
          height: '158px',
          position: 'absolute',
          overflow: 'inherit',
          top: '75px',
          left: '374px',
          backgroundColor: '#000',
        }}
      >
        {isImageFile(contentType) && (
          <img src={mediaUrl} alt={'Extra large touch preview'} style={{borderRadius: '3px'}}/>
        )}
        {isVideoFile(contentType) && (
          <video controls={true} autoPlay={true} muted={true} loop={true}>
            <source src={mediaUrl} type={contentType}/>
            Your browser does not support video
          </video>
        )}
      </div>
    </div>
  )
}
